import { render } from "./Tooltip.vue?vue&type=template&id=21c2e53a&scoped=true&ts=true"
import script from "./Tooltip.vue?vue&type=script&lang=ts"
export * from "./Tooltip.vue?vue&type=script&lang=ts"

import "./Tooltip.vue?vue&type=style&index=0&id=21c2e53a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c2e53a"]])

export default __exports__